/* src/app/order/order-restart-dialog/order-restart-dialog.component.scss */
ion-icon.close-icon {
  width: 22px;
  height: 22px;
}
ion-icon.alert-icon {
  width: 30px;
  height: 30px;
}
.alert-text {
  color: #000;
  font-family: "Barlow Semi Condensed", sans-serif;
  font-size: 22px;
  font-style: normal;
  font-weight: 500;
  line-height: 32px;
}
hr {
  height: 1px;
  background: #cbcbcb;
  width: 100%;
  margin: 22px 0;
}
h1 {
  color: #000;
  font-family: "Barlow Semi Condensed", sans-serif;
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
p {
  color: #949494;
  font-family: "Barlow Semi Condensed", sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 30px;
}
p.color-red {
  color: #ff4f4f !important;
}
.check-text {
  color: #000;
  font-family: "Barlow Semi Condensed", sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
}
/*# sourceMappingURL=order-restart-dialog.component-RNOY62GT.css.map */
